import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useMatomo } from '@jonkoops/matomo-tracker-react';

export const usePageTracking = () => {
    const location = useLocation();
    const { trackPageView } = useMatomo();

    useEffect(() => {
        trackPageView({
            documentTitle: document.title,
        });
    }, [location, trackPageView]);
};